import filterUniqueByImage from './filterUniqueByImage';

export default function getImagesFromOnlinePaymentMethods(paymentMethods) {
  let cardsImages = [];
  paymentMethods.forEach(paymentMethod => {
    if (paymentMethod.onlineOptions && paymentMethod.onlineOptions.length) {
      cardsImages = cardsImages.concat(
        filterUniqueByImage(paymentMethod.onlineOptions),
      );
    }
  });
  return cardsImages;
}
